import { z } from 'zod';
import { CoordinatesSchema } from './property.js';

export const RegionStatusSchema = z.enum(['active', 'inactive']);
export type RegionStatus = z.infer<typeof RegionStatusSchema>;

export const RegionBoundsSchema = z.object({
  north: z.number(),
  south: z.number(),
  east: z.number(),
  west: z.number(),
});
export type RegionBounds = z.infer<typeof RegionBoundsSchema>;

export const SupportedRegionSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  center: CoordinatesSchema,
  radiusMiles: z.number().optional(),
  polygon: z.array(CoordinatesSchema),
  bounds: RegionBoundsSchema,
  status: RegionStatusSchema,
  launchDate: z.string().optional(),
});
export type SupportedRegion = z.infer<typeof SupportedRegionSchema>;

export const CreateRegionRequestSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string().optional(),
  polygon: z.array(CoordinatesSchema).min(3, 'At least 3 boundary points required'),
  status: RegionStatusSchema.default('active'),
  launchDate: z.string().nullable().optional(),
});
export type CreateRegionRequest = z.infer<typeof CreateRegionRequestSchema>;

export const UpdateRegionRequestSchema = CreateRegionRequestSchema.partial();
export type UpdateRegionRequest = z.infer<typeof UpdateRegionRequestSchema>;
